/**
 * PricingFAQDark - FAQ section dark theme avec les questions du prompt
 */

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

// FAQ avec les questions EXACTES du prompt
const FAQ_ITEMS = [
  {
    question: "Puis-je changer de plan à tout moment ?",
    answer:
      "Oui, vous pouvez upgrader ou downgrader votre plan à tout moment. Le changement prend effet immédiatement et la facturation est ajustée au prorata.",
  },
  {
    question: "Y a-t-il des frais cachés ?",
    answer:
      "Non, aucun frais caché. Le prix affiché inclut toutes les fonctionnalités du plan. Seuls les utilisateurs supplémentaires sont facturés en plus.",
  },
  {
    question: "Comment fonctionne l'essai gratuit ?",
    answer:
      "Vous avez 14 jours pour tester B8ild avec toutes les fonctionnalités du plan Pro. La carte bancaire est requise mais vous ne serez débité qu'après l'essai.",
  },
  {
    question: "Que se passe-t-il si je dépasse mes limites ?",
    answer:
      "Nous vous prévenons avant d'atteindre vos limites. Vous pouvez alors upgrader votre plan ou attendre le mois suivant pour que les compteurs se réinitialisent.",
  },
  {
    question: "Puis-je annuler à tout moment ?",
    answer:
      "Oui, sans engagement. Vous pouvez annuler en un clic depuis votre espace. Vos données restent accessibles 30 jours après l'annulation.",
  },
  {
    question: "Proposez-vous des réductions pour les associations ou écoles ?",
    answer:
      "Oui, nous offrons -50% pour les associations et les écoles de formation BTP. Contactez-nous avec un justificatif.",
  },
  {
    question: "Comment fonctionne la facturation annuelle ?",
    answer:
      "Vous payez pour 12 mois d'un coup et économisez 20% par rapport au tarif mensuel. La facture est émise immédiatement.",
  },
  {
    question: "Mes données sont-elles sécurisées ?",
    answer:
      "Oui, B8ild est hébergé en France et conforme RGPD. Vos données sont chiffrées et sauvegardées quotidiennement.",
  },
];

export function PricingFAQDark() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="relative py-24">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute bottom-0 right-1/4 w-[500px] h-[300px] bg-[#F59E0B]/5 rounded-full blur-[150px]" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Questions sur les tarifs
          </h2>
          <p className="text-white/50 max-w-2xl mx-auto">
            Tout ce que vous devez savoir avant de vous lancer.
          </p>
        </div>

        {/* FAQ Items */}
        <div className="max-w-3xl mx-auto space-y-3">
          {FAQ_ITEMS.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className={cn(
                  "rounded-xl border transition-all duration-300",
                  isOpen
                    ? "border-[#F59E0B]/30 bg-[#F59E0B]/[0.03]"
                    : "border-white/[0.05] bg-white/[0.02] hover:bg-white/[0.03]"
                )}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full flex items-center justify-between p-5 text-left"
                >
                  <span
                    className={cn(
                      "font-medium transition-colors",
                      isOpen ? "text-[#F59E0B]" : "text-white"
                    )}
                  >
                    {item.question}
                  </span>
                  <ChevronDown
                    className={cn(
                      "h-5 w-5 flex-shrink-0 ml-4 transition-all duration-300",
                      isOpen
                        ? "rotate-180 text-[#F59E0B]"
                        : "text-white/40"
                    )}
                  />
                </button>

                <div
                  className={cn(
                    "grid transition-all duration-300",
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  )}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-white/60 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default PricingFAQDark;
